import { FC } from 'react';

import { useTextOverflow } from '@fuxi/eevee-hooks';
import { EnhancedLink } from '@portalCommon/components';
import classnames from 'classnames/bind';
import { RouterConfigEnum } from '@portalCommon/constants';
import { OptimizedImg } from '@commonPackage/components';
import { PcCardItem as CardItem } from '@/styles/utils';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface ItemProps {
  url: string;
  title: string;
  brief_intro: string;
  id?: string;
}

interface CardProps {
  item: ItemProps;
  click: (e: any, item: ItemProps) => void;
}

const Card: FC<CardProps> = ({ item, click }) => {
  const { textRef: briefRef } = useTextOverflow();
  return (
    <CardItem width={384} height={336} onClick={e => click(e, item)}>
      <EnhancedLink rel="preload" to={`/${RouterConfigEnum.SceneCasePre}/${item.id}`}>
        <OptimizedImg className={cx('cover-image')} src={item.url} alt={item.url} />
        <h1 className={cx('title')}>{item.title}</h1>
        <p className={cx('brief')} ref={briefRef}>
          {item.brief_intro}
        </p>
      </EnhancedLink>
    </CardItem>
  );
};

export default Card;
